module.exports = __webpack_public_path__ + "img/player.b407a25b.png";